"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BurningOfCyrusAbilityHandler = exports.BurningOfCyrusActorAbilityFactory = exports.BurningOfCyrusAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Burning_1 = require("../../core/effects/core/Burning");
const Registries_1 = require("../../core/state/Registries");
const Instant_1 = require("../../core/vfx/core/Instant");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class BurningOfCyrusAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.BurningOfCyrus;
        this.__typeName = "BurningOfCyrus";
    }
}
exports.BurningOfCyrusAbilityArgs = BurningOfCyrusAbilityArgs;
let BurningOfCyrusActorAbilityFactory = class BurningOfCyrusActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("BurningOfCyrus", "OneEnemies", 4);
    }
};
BurningOfCyrusActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("BurningOfCyrus")
], BurningOfCyrusActorAbilityFactory);
exports.BurningOfCyrusActorAbilityFactory = BurningOfCyrusActorAbilityFactory;
let BurningOfCyrusAbilityHandler = class BurningOfCyrusAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Fire", 100)
            ],
            onHitOrMiss: (sequence, { hit }) => sequence.push(new Instant_1.InstantVfxStepArgs(hit ? new LocationSelector_1.ActorVfxLocationSelector(selectedEnemy, "feet")
                : LocationSelector_1.ActorVfxLocationSelector.Miss(selectedEnemy), "BlueFlameStrike")),
            onHit(sequence) {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new Burning_1.BurningEffectArgs("Focus", 10),
                });
            }
        });
    }
};
BurningOfCyrusAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.BurningOfCyrus)
], BurningOfCyrusAbilityHandler);
exports.BurningOfCyrusAbilityHandler = BurningOfCyrusAbilityHandler;
